export enum RateTableWeightUnit {
  Oz = "OZ",
  Lb = "LB",
  Kg = "KG",
}
